import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section className="banner_h100 save_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <div className="logo_nurs">
              <StaticImage
                src="../../../images/case-studies/save-win/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={166}
                height={153}
              />
            </div>
            <h1 className="h2">Save & Win App</h1>
            <p>
              Save & Win is a mobile application that encourages users to save
              money and get rewarded for it. Basically, this type of
              money-saving application allows users to compare the prices of
              their favorite products available online and let them know how
              much they’re saving on each project.
            </p>
            <p>
              The following application includes a Price Comparison module. Via
              this application, users can search and compare a specific product
              across multiple retailers and stores. In that way, they can find
              the best deals for their purchases.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center my-auto offset-xl-1"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/save-win/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={914}
                height={733}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
